import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/custom_page_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  title_cont: {
    model_name: 'CustomPage',
    column_type: 'string',
    column_name: 'title',
  },
  slug_cont: {
    model_name: 'CustomPage',
    column_type: 'string',
    column_name: 'slug',
  },
}
export const formColumnsConfig = {
  'self': {
    'title': { required: true, disabledUpdate: false },
    'slug': { required: true, disabledUpdate: true },
    'configs': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('CustomPage', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('CustomPage', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
